import React from 'react';
import moment from 'moment';

export const ReplenishmentQuantity = (props) => {

    return (
        <input type="number" min={1} max={props.max} value={props.value} name="" className="form-control" style={{fontSize: 'small', padding: '0.5rem 0.25rem'}} onChange={props.onChange}/>
    )
};

export default ReplenishmentQuantity;


// WEBPACK FOOTER //
// ./src/admin/scheduledreplenishment/ReplenishmentQuantity.js